import { useEffect, useState } from 'react';
import { getAnnouncements } from '../../services/apiClient';
import type { Announcement } from '../../types';
import { formatDate } from '../../lib/formatting';
import { EmptyState } from '../../components/ui/EmptyState';
import styles from './NewsPage.module.css';

export function NewsPage() {
  const [announcements, setAnnouncements] = useState<Announcement[]>([]);

  useEffect(() => {
    getAnnouncements().then((r) => r.data && setAnnouncements(r.data));
  }, []);

  return (
    <div className={styles.page}>
      <div className={styles.pageHeader}>
        <div className="container">
          <h1 className={styles.title}>News & Announcements</h1>
        </div>
      </div>
      <div className="container">
        {announcements.length === 0 ? (
          <EmptyState title="No announcements yet" />
        ) : (
          <div className={styles.list}>
            {announcements.map((ann) => (
              <article key={ann.id} className={styles.item}>
                <p className={styles.date}>{formatDate(ann.publish_date)}</p>
                <h2 className={styles.itemTitle}>{ann.title}</h2>
                <p className={styles.body}>{ann.body}</p>
              </article>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
